import Vue from "vue";
import Vuex from "vuex";
import Lockr from "lockr";

Vue.use(Vuex);

function initialState() {
  Lockr.prefix = "designer_";
  return {
    html: Lockr.get("html")
  };
}

export default new Vuex.Store({
  state: initialState,
  mutations: {
    updateHTML(state, html) {
      state.html = html;
      Lockr.set("html", html);
    }
  },
  actions: {},
  modules: {}
});
